"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryConditionsComparison = exports.BoundaryConditionRowSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const value_comparison_1 = require("../../Comparison/value-comparison");
const si_comparison_1 = require("../../Comparison/si-comparison");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const comparison_spec_1 = require("../comparison-spec");
exports.BoundaryConditionRowSchema = z.object({
    signalName: z.string(),
    relativeToSignalName: z.string(),
    characteristic: z.string(),
    conditions: z.string(),
    minimum: z.string().nullable(),
    nominal: z.string().nullable(),
    maximum: z.string().nullable(),
    sourceConditions: z.unknown().optional(),
});
const KEY_COLUMNS = [
    'signalName',
    'relativeToSignalName',
    'characteristic',
    'conditions',
];
const VALUE_COLUMNS = ['minimum', 'nominal', 'maximum'];
const SI_VALUE_COLUMNS = new Set(['minimum', 'nominal', 'maximum']);
const SIGNAL_NAME_COLUMNS = new Set(['signalName', 'relativeToSignalName']);
class BoundaryConditionsComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.CellAlignment(KEY_COLUMNS, VALUE_COLUMNS);
        this.membershipScopeColumns = ['signalName'];
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (SIGNAL_NAME_COLUMNS.has(column) && typeof value === 'string') {
            return (0, signal_name_normalization_1.normalizeSignalNameForComparison)(value);
        }
        if (SI_VALUE_COLUMNS.has(column) && typeof value === 'string') {
            const characteristic = sigma_engine_shared_1.BoundaryCharacteristicSchema.safeParse(row?.characteristic);
            if (characteristic.success) {
                return (0, si_comparison_1.formatSIOrSymbolicValue)(value, characteristic.data);
            }
        }
        return super.normalize(column, value, row);
    }
}
exports.BoundaryConditionsComparison = BoundaryConditionsComparison;
//# sourceMappingURL=boundary-conditions.comparison.js.map